import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { api } from "../../api";
import { LoginRequest } from "api/controlPlaneApi";
import { ErrorResponseHandler } from "../../common/types";
import { setErrorSnackBarMessage, userLogged } from "screens/systemSlice";
import { ILoginDetail, loginStrategyType } from "./types";
import { setLoggedIn, setNavigateFrom } from "./loginSlice";
import { setSessionState } from "./sessionSlice";

export const loginAsync = createAsyncThunk(
  "login/loginAsync",
  async (_, { getState, rejectWithValue, dispatch }) => {
    const state = getState() as RootState;

    let req: LoginRequest;
    if (state.login.mfaToken !== "") {
      req = {
        mfa_token: state.login.mfaToken,
        otp: state.login.otp,
        accessKey: state.login.accessKey,
      };
    } else {
      req = {
        accessKey: state.login.accessKey,
        secretKey: state.login.secretKey,
      };
    }
    return api.login
      .login(req)
      .then((res) => {
        dispatch(setSessionState("valid"));
        dispatch(userLogged(true));
        dispatch(setLoggedIn(true));
      })
      .catch((err) => {
        dispatch(setErrorSnackBarMessage(err));
      });
  },
);
export const getFetchConfigurationAsync = createAsyncThunk(
  "login/getFetchConfigurationAsync",
  async (_, { getState, rejectWithValue, dispatch }) => {
    return api.login
      .loginDetail()
      .then((res) => {
        let loginDetails: ILoginDetail[] = [];
        for (let loginStrategem of res.data.loginDetail!!) {
          let loginDetail: ILoginDetail = {
            loginStrategy: loginStrategyType.unknown,
            redirectRules: [],
          };
          switch (loginStrategem.loginStrategy!!) {
            case "redirect":
              loginDetail.loginStrategy = loginStrategyType.redirect;
              setNavigateFrom(loginStrategem.navigateFrom!!);
              break;
            case "form":
              loginDetail.loginStrategy = loginStrategyType.form;
              break;
            case "service-account":
              loginDetail.loginStrategy = loginStrategyType.serviceAccount;
              break;
            case "redirect-service-account":
              loginDetail.loginStrategy =
                loginStrategyType.redirectServiceAccount;
              setNavigateFrom(loginStrategem.navigateFrom!!);
              break;
          }
          loginDetail.redirectRules = loginStrategem.redirectRules!!;
          loginDetail.isK8S = loginStrategem.isK8S;
          loginDetail.navigateFrom = loginStrategem.navigateFrom;
          loginDetails.push(loginDetail);
        }
        return loginDetails;
      })
      .catch((err: ErrorResponseHandler) => {
        dispatch(setErrorSnackBarMessage(err));
      });
  },
);
